import ModalTour from "./ModalReceiveGoal";
export default ModalTour;
